// import { useEffect, useState } from "react";
// import config from '../../config';
// import { ChevronDown, ChevronUp } from "lucide-react";
// import './DueCus.css';
// import PayModal from './PayModal';

// const AllDue = () => {
//     const expandedColumns = ['Invoice Number', 'Head', 'Sold Date', 'Total Amount', 'Paid Amount', 'Due Amount', 'Actions'];
  
//     const [data, setData] = useState([]);
//     const [isLoading, setIsLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [expandedRows, setExpandedRows] = useState([]);
//     const [showModal, setShowModal] = useState(false);
//     const [selectedInvoice, setSelectedInvoice] = useState(null);
  
//     useEffect(() => {
//       fetchDueCustomer();
//     }, []);
  
//     const fetchDueCustomer = async () => {
//       try {
//         const response = await fetch(`${config.BASE_URL}/invoices`);
//         if (!response.ok) {
//           setError('Failed to fetch Sales Invoices');
//           return;
//         }
//         const invoices = await response.json();
  
//         const transactionPromises = invoices.map(async (invoice) => {
//           const transactionResponse = await fetch(`${config.BASE_URL}/transaction/invoice/${invoice.invoiceId}`);
//           if (transactionResponse.ok) {
//             return await transactionResponse.json();
//           }
//           return [];
//         });
  
//         const transactionsData = await Promise.all(transactionPromises);
  
//         const formattedData = invoices.map((invoice, index) => {
//           const invoiceTransactions = transactionsData[index] || [];
//           const creditTransactions = invoiceTransactions.filter(transaction => transaction.transactionType === 'credit');
//           if (creditTransactions.length === 0) return null;
  
//           const transactionPaid = creditTransactions.reduce((total, transaction) => total + transaction.paid, 0);
//           const transactionDue = creditTransactions.reduce((total, transaction) => total + transaction.due, 0);
//           const transactionPrice = creditTransactions.reduce((total, transaction) => total + transaction.price, 0);
  
//           return {
//             invoiceId: invoice.invoiceId,
//             invoiceNo: invoice.invoiceNo,
//             customerCode: invoice.customer.cusCode,
//             customerName: invoice.customer.cusName,
//             cusId: invoice.customer.cusId,
//             store: invoice.store,
//             date: invoice.invoiceDate,
//             totalAmount: transactionPrice,
//             paidAmount: transactionPaid,
//             dueAmount: transactionDue,
//           };
//         }).filter(Boolean);
  
//         setData(formattedData);
//       } catch (err) {
//         setError(err.message);
//       } finally {
//         setIsLoading(false);
//       }
//     };
  
//     const toggleRowExpansion = (customerCode) => {
//       if (expandedRows.includes(customerCode)) {
//         setExpandedRows(expandedRows.filter(code => code !== customerCode));
//       } else {
//         setExpandedRows([...expandedRows, customerCode]);
//       }
//     };
  
//     const handlePayClick = (invoice) => {
//       setSelectedInvoice({
//         ...invoice,
//         cusId: invoice.customer?.cusId // Get cusId from customer object in invoice data
//       });
//       setShowModal(true);
//     };
  
//     const handleCloseModal = () => {
//       setShowModal(false);
//       setSelectedInvoice(null);
//     };
  
//     return (
//       <div>
//         <div className="scrolling-container">
//           <div className="new-sales-container">
//             <h4>All Due Payments</h4>
  
//             {isLoading ? (
//               <p>Loading...</p>
//             ) : error ? (
//               <p>Error: {error}</p>
//             ) : null}
  
//             <table className="due-cus-table">
//               <thead>
//                 <tr>
//                   {expandedColumns.map((column, index) => (
//                     <th key={index}>{column}</th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {data
//                   .filter(row => row.dueAmount > 0) // Filter rows with Total Due Amount > 0
//                   .map((item, index) => (
//                     <tr key={index}>
//                       <td>{item.invoiceNo}</td>
//                       <td>{item.store}</td>
//                       <td>{new Date(item.date).toLocaleString()}</td>
//                       <td>{item.totalAmount}</td>
//                       <td>{item.paidAmount}</td>
//                       <td>{item.dueAmount}</td>
//                       <td>
//                         <button
//                           className="btn btn-success"
//                           onClick={() => handlePayClick({
//                             ...item,
//                             customer: { cusId: item.cusId } // Include customer ID from the row data
//                           })}
//                         >
//                           Payment
//                         </button>
//                       </td>
//                     </tr>
//                   ))}
//               </tbody>
//             </table>
            
//             {showModal && selectedInvoice && (
//               <PayModal
//                 show={showModal}
//                 handleClose={handleCloseModal}
//                 invoiceData={selectedInvoice}
//               />
//             )}
//           </div>
//         </div>
//       </div>
//     );
//   };
  
//   export default AllDue;


//v2 without pagination
// import { useEffect, useState } from "react";
// import config from '../../config';
// import './DueCus.css';
// import PayModal from './PayModal';

// const AllDue = () => {
//   const expandedColumns = ['Invoice Number', 'Customer Name','Customer Office','Sold Date', 'Total Amount', 'Paid Amount', 'Due Amount', 'Actions'];

//   const [data, setData] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [selectedInvoice, setSelectedInvoice] = useState(null);

//   useEffect(() => {
//     fetchDueCustomer();
//   }, []);

//   const fetchCustomerName = async (cusId) => {
//     try {
//       const response = await fetch(`${config.BASE_URL}/customer/${cusId}`);
//       if (response.ok) {
//         const customer = await response.json();
//         return customer.cusName;
//       }
//       return 'Unknown Customer';
//     } catch {
//       return 'Unknown Customer';
//     }
//   };

//   const fetchDueCustomer = async () => {
//     try {
//       const response = await fetch(`${config.BASE_URL}/invoices`);
//       if (!response.ok) {
//         setError('Failed to fetch Sales Invoices');
//         return;
//       }
//       const invoices = await response.json();

//       const transactionPromises = invoices.map(async (invoice) => {
//         const transactionResponse = await fetch(`${config.BASE_URL}/transaction/invoice/${invoice.invoiceId}`);
//         if (transactionResponse.ok) {
//           return await transactionResponse.json();
//         }
//         return [];
//       });

//       const transactionsData = await Promise.all(transactionPromises);

//       const customerNameCache = {}; // Cache to avoid redundant API calls for the same cusId

//       const formattedData = await Promise.all(
//         invoices.map(async (invoice, index) => {
//           const invoiceTransactions = transactionsData[index] || [];
//           const creditTransactions = invoiceTransactions.filter(transaction => transaction.transactionType === 'credit');
//           if (creditTransactions.length === 0) return null;

//           const transactionPaid = creditTransactions.reduce((total, transaction) => total + transaction.paid, 0);
//           const transactionDue = creditTransactions.reduce((total, transaction) => total + transaction.due, 0);
//           const transactionPrice = creditTransactions.reduce((total, transaction) => total + transaction.price, 0);

//           let customerName = customerNameCache[invoice.customer?.cusId];
//           if (!customerName) {
//             customerName = await fetchCustomerName(invoice.customer?.cusId);
//             customerNameCache[invoice.customer?.cusId] = customerName; // Store in cache
//           }

//           return {
//             invoiceId: invoice.invoiceId,
//             invoiceNo: invoice.invoiceNo,
//             customerName, // Dynamically fetched customer name
//             customerOffice:invoice.customer?.cusOffice || '-',
//             cusId: invoice.customer?.cusId || '-',
//             store: invoice.store,
//             date: invoice.invoiceDate,
//             totalAmount: transactionPrice,
//             paidAmount: transactionPaid,
//             dueAmount: transactionDue,
//           };
//         })
//       );

//       setData(formattedData.filter(Boolean));
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handlePayClick = (invoice) => {
//     setSelectedInvoice({
//       ...invoice,
//       cusId: invoice.cusId || "-"
//     });
//     setShowModal(true);
//   };
  

//   const handleCloseModal = () => {
//     setShowModal(false);
//     setSelectedInvoice(null);
//   };

//   return (
//     <div>
//       <div className="scrolling-container">
//         <div className="new-sales-container">
//           <h4>Invoices Due</h4>

//           {isLoading ? (
//             <p>Loading...</p>
//           ) : error ? (
//             <p>Error: {error}</p>
//           ) : null}

//           <table className="due-cus-table">
//             <thead>
//               <tr>
//                 {expandedColumns.map((column, index) => (
//                   <th key={index}>{column}</th>
//                 ))}
//               </tr>
//             </thead>
//             <tbody>
//               {data
//                 .filter(row => row.dueAmount > 0) // Filter rows with Total Due Amount > 0
//                 .map((item, index) => (
//                   <tr key={index}>
//                     <td>{item.invoiceNo}</td>
//                     <td>{item.customerName}</td>
//                     <td>{item.customerOffice}</td>
//                     <td>{new Date(item.date).toLocaleString()}</td>
//                     <td>{item.totalAmount}</td>
//                     <td>{item.paidAmount}</td>
//                     <td>{item.dueAmount}</td>
//                     <td>
//                       <button
//                         className="btn btn-success"
//                         onClick={() => handlePayClick(item)}
//                       >
//                         Payment
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//             </tbody>
//           </table>

//           {showModal && selectedInvoice && (
//             <PayModal
//               show={showModal}
//               handleClose={handleCloseModal}
//               invoiceData={selectedInvoice}
//             />
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AllDue;


//v3 with pagination

import { useEffect, useState } from "react";
import config from '../../config';
import './DueCus.css';
import PayModal from './PayModal';
import toast from "react-hot-toast";

const AllDue = () => {
  const expandedColumns = ['Invoice Number', 'Customer Name','Customer Office','Sold Date', 'Total Amount', 'Paid Amount', 'Due Amount', 'Actions'];

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    fetchDueCustomer();
  }, []);

  const fetchCustomerName = async (cusId) => {
    try {
      const response = await fetch(`${config.BASE_URL}/customer/${cusId}`);
      if (response.ok) {
        const customer = await response.json();
        return customer.cusName;
      }
      return 'Unknown Customer';
    } catch {
      return 'Unknown Customer';
    }
  };

  const fetchDueCustomer = async () => {
    try {
      const response = await fetch(`${config.BASE_URL}/invoices`);
      if (!response.ok) {
        setError('Failed to fetch Sales Invoices');
        return;
      }
      const invoices = await response.json();

      const transactionPromises = invoices.map(async (invoice) => {
        const transactionResponse = await fetch(`${config.BASE_URL}/transaction/invoice/${invoice.invoiceId}`);
        if (transactionResponse.ok) {
          return await transactionResponse.json();
        }
        return [];
      });

      const transactionsData = await Promise.all(transactionPromises);

      const customerNameCache = {}; // Cache to avoid redundant API calls for the same cusId

      const formattedData = await Promise.all(
        invoices.map(async (invoice, index) => {
          const invoiceTransactions = transactionsData[index] || [];
          const creditTransactions = invoiceTransactions.filter(transaction => transaction.transactionType === 'credit');
          if (creditTransactions.length === 0) return null;

          const transactionPaid = creditTransactions.reduce((total, transaction) => total + transaction.paid, 0);
          const transactionDue = creditTransactions.reduce((total, transaction) => total + transaction.due, 0);
          const transactionPrice = creditTransactions.reduce((total, transaction) => total + transaction.price, 0);

          let customerName = customerNameCache[invoice.customer?.cusId];
          if (!customerName) {
            customerName = await fetchCustomerName(invoice.customer?.cusId);
            customerNameCache[invoice.customer?.cusId] = customerName; // Store in cache
          }

          return {
            invoiceId: invoice.invoiceId,
            invoiceNo: invoice.invoiceNo,
            customerName, // Dynamically fetched customer name
            customerOffice:invoice.customer?.cusOffice || '-',
            cusId: invoice.customer?.cusId || '-',
            store: invoice.store,
            date: invoice.invoiceDate,
            totalAmount: transactionPrice,
            paidAmount: transactionPaid,
            dueAmount: transactionDue,
          };
        })
      );

      // Filter out null values
      let processedData = formattedData.filter(Boolean);
      
      // Sort by invoice number in ascending order (oldest first)
      processedData.sort((a, b) => {
        // If invoiceNo is numeric
        return parseInt(a.invoiceNo) - parseInt(b.invoiceNo);
        
        // If invoiceNo is string with format like INV-001
        // return a.invoiceNo.localeCompare(b.invoiceNo);
      });
      
      // Filter for items with due amount > 0
      const filteredData = processedData.filter(row => row.dueAmount > 0);
      
      // Calculate total pages
      const calculatedTotalPages = Math.ceil(filteredData.length / itemsPerPage);
      setTotalPages(calculatedTotalPages);
      
      // Set current page to last page initially to show newest invoices first
      setCurrentPage(calculatedTotalPages);
      
      setData(filteredData);
    } catch (err) {
      setError(err.message);
      toast.error("Failed to fetch Sales Invoices",err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePayClick = (invoice) => {
    setSelectedInvoice({
      ...invoice,
      cusId: invoice.cusId || "-"
    });
    setShowModal(true);
  };
  
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedInvoice(null);
  };

  // Calculate current page's data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <div>
      <div className="scrolling-container">
        <div className="new-sales-container">
          <h4>Invoices Due</h4>

          {isLoading ? (
            <p>Loading...</p>
          ) : error ? (
            <p>Error: {error}</p>
          ) : null}

          <table className="due-cus-table">
            <thead>
              <tr>
                {expandedColumns.map((column, index) => (
                  <th key={index}>{column}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {currentItems.map((item, index) => (
                <tr key={index}>
                  <td>{item.invoiceNo}</td>
                  <td>{item.customerName}</td>
                  <td>{item.customerOffice}</td>
                  <td>{new Date(item.date).toLocaleString()}</td>
                  <td>{item.totalAmount}</td>
                  <td>{item.paidAmount}</td>
                  <td>{item.dueAmount}</td>
                  <td>
                    <button
                      className="btn btn-success"
                      onClick={() => handlePayClick(item)}
                    >
                      Payment
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {totalPages > 1 && (
            <div className="pagination justify-content-center mt-3">
              <button
                className="btn btn-primary"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage <= 1}
              >
                Previous
              </button>
              
              {/* First page */}
              {totalPages > 1 && (
                <span
                  className={`mx-1 px-2 py-1 border ${currentPage === 1 ? 'border-primary fw-bold' : 'border-transparent'}`}
                  style={{ cursor: "pointer" }}
                  onClick={() => handlePageChange(1)}
                >
                  1
                </span>
              )}
              
              {currentPage > 3 && <span className="mx-1">...</span>}
              
              {/* Page Numbers */}
              {Array.from({ length: 5 }, (_, i) => currentPage - 2 + i)
                .filter(page => page > 1 && page < totalPages)
                .map(page => (
                  <span
                    key={page}
                    className={`mx-1 px-2 py-1 border ${page === currentPage ? 'border-dark fw-bold' : 'border-transparent'}`}
                    style={{ cursor: "pointer" }}
                    onClick={() => handlePageChange(page)}
                  >
                    {page}
                  </span>
                ))
              }
              
              {currentPage < totalPages - 2 && <span className="mx-1">...</span>}
              
              {/* Last page */}
              {totalPages > 1 && (
                <span
                  className={`mx-1 px-2 py-1 border ${currentPage === totalPages ? 'border-dark fw-bold' : 'border-transparent'}`}
                  style={{ cursor: "pointer" }}
                  onClick={() => handlePageChange(totalPages)}
                >
                  {totalPages}
                </span>
              )}
              
              <button
                className="btn btn-primary"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage >= totalPages}
              >
                Next
              </button>
            </div>
          )}

          {showModal && selectedInvoice && (
            <PayModal
              show={showModal}
              handleClose={handleCloseModal}
              invoiceData={selectedInvoice}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default AllDue;